var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v("\n                        " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + "\n                    ")], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [(visit.state === 'scheduled') ? [_c('button', {
      staticClass: "btn btn-sm btn-warning",
      on: {
        "click": function($event) {
          _vm.showModalClientVisitChange(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-plus-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" přeobjednat")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.cancelVisit(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit návštěvu")])] : _vm._e(), _c('br'), _vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        ")], 2)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? _vm._l((diagnose.actions), function(action) {
        return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                ")])])
      }) : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]), _vm._v(" "), _c('client-visit-change', {
    attrs: {
      "opened": _vm.modalChangeVisitOpened,
      "visit-id": _vm.modalChangeVisitId
    },
    on: {
      "update": _vm.updateVisits
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3388e55a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientMessage.vue
// module id = 639
// module chunks = 0